/****************************************************
 * Module Name:  addColumnRoleModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip, Typography } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import Utility from "../../utility/utility";
import UserProxy from "../../utility/proxy/manager/userProxy";
import { MultiSelect } from "../common/reactSelectWithSelectAll";
import { LoadingButton } from "@mui/lab";
import UserColumnPermissionProxy from "../../utility/proxy/manager/permissionProxy/userColumnPermissionProxy";
import ColumnRoleProxy from "../../utility/proxy/manager/permissionProxy/columnRoleProxy";
import SaveIcon from '@mui/icons-material/Save';
import Select from "react-select";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

export default class AddColumnRoleModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newPermission: this.props.editOperation
                ? this.setPropSourceDataofRolePermissions(
                    this.props.sourceData.rolepermissions
                )
                : "",
            newdescription: this.props.editOperation
                ? this.props.sourceData.description
                : "",
            newRoleOwners: this.props.editOperation
                ? this.setPropSourceDataofRoleOwners(this.props.sourceData.roleowners)
                : "",
            newRole: this.props.editOperation ? this.props.sourceData.name : "",

            showError: false,

            validateRolePresentSpinner: false,
            showValidationMessage: false,
            roleAvailable: true,

            permissionOptions: [],
            showPermissionLoadSpinner: true,

            userOptions: [],
            showUserLoadSpinner: true,

            roleValidationError: "",

            userInputValue: "",
            debouncedInputValue: "",
            showUserDetailModal: false,
        };
        this.getAllPermission(false);
        this.getAllUser(false);
    };

    fullOptionToPermissionValue = (selectedData) => {
        let newArr = [];
        selectedData.map((option) => {
            newArr.push({ permissioncolumnname: option.label, permissionid: option.value });
            return true;
        });
        return newArr.includes("*") ? [] : newArr;
    };

    fullOptionToOwnerValue = (selectedData) => {
        let newArr = [];
        selectedData.map((option) => {
            newArr.push({ userid: option.value });
            return true;
        });
        return newArr.includes("*") ? [] : newArr;
    };

    setPropSourceDataofRoleOwners = (dataToMap) => {
        let newArr = [];
        dataToMap.map((item) => {
            let option = { value: item.userid, label: item.username };
            newArr.push(option);
            return true;
        });
        return newArr;
    };

    setPropSourceDataofRolePermissions = (dataToMap) => {
        let newArr = [];
        dataToMap.map((item) => {
            let option = { value: item.permissionid, label: item.name };
            newArr.push(option);
            return true;
        });
        return newArr;
    };

    getAllPermission = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showPermissionLoadSpinner: true });
        UserColumnPermissionProxy.GetAllColumnPermissionMini((response) =>
            this.setAllPermissionData(response)
        );
    };

    setAllPermissionData = (response) => {
        let optionsArray = [];

        Object.entries(response).forEach(([key, value]) => {
            let option = { value: key, label: value };
            optionsArray.push(option);
        });

        this.setState({
            permissionOptions: optionsArray,
            newPermission:
                this.state.newPermission === "" && optionsArray.length > 0
                    ? [optionsArray[0]]
                    : this.state.newPermission,
            showPermissionLoadSpinner: false,
        });
    };

    getAllUser = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showUserLoadSpinner: true });
        UserProxy.GetAllGenericUserMini((response) =>
            this.setAllUserData(response)
        );
    };

    setAllUserData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = { value: data.id, label: data.id + " | " + data.username };
            optionsArray.push(option);
            return true;
        });
        this.setState({
            userOptions: optionsArray,
            newRoleOwners:
                this.state.newRoleOwners === "" && optionsArray.length > 0
                    ? [
                        optionsArray.find(
                            (option) => option.value === Constants.loggedInUser.id
                        ),
                    ]
                    : this.state.newRoleOwners,
            showUserLoadSpinner: false,
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.userInputValue !== this.state.userInputValue) {
            this.setState({ debouncedInputValue: this.state.userInputValue });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    getFilteredUserOptions() {
        const { debouncedInputValue } = this.state;

        if (!debouncedInputValue) {
            return this.state.userOptions.slice(0, 100);
        }
        return this.state.userOptions
            .filter(option =>
                option.label.toLowerCase().includes(debouncedInputValue.toLowerCase())
            )
            .slice(0, 500);
    }

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            name: this.state.newRole,
            description: this.state.newdescription,
            rolepermissions: this.fullOptionToPermissionValue(this.state.newPermission),
            roleowners: this.fullOptionToOwnerValue(this.state.newRoleOwners),
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data)) this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    validateRolePresent = (roleEntered) => {
        if (!roleEntered || roleEntered.trim() === "") return;

        this.setState({
            validateRolePresentSpinner: true,
        });

        ColumnRoleProxy.CheckRoleAvailable(roleEntered, (response) => {
            //if we got response that means role is present at backend
            if (response) {
                //RoleName already present
                this.setState({
                    validateRolePresentSpinner: false,
                    showValidationMessage: true,
                    roleAvailable: false,
                });
            } else {
                //RoleName not available, so can be used
                this.setState({
                    validateRolePresentSpinner: false,
                    showValidationMessage: true,
                    roleAvailable: true,
                });
            }
        });
    };

    buttonDisable = () => {
        if (
            this.props.editOperation &&
            (this.state.newPermission.length === 0 ||
                this.state.newRoleOwners.length === 0)
        )
            return true;

        if (!this.props.editOperation)
            return (
                !this.state.showValidationMessage ||
                !this.state.roleAvailable ||
                this.state.newPermission.length === 0 ||
                this.state.newRoleOwners.length === 0 ||
                this.state.newRole.length === 0
            );

        return false;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add role validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />
                {this.state.showUserDetailModal ? (
                    <UserDetailModal
                        show={true}
                        handleClose={() => this.setState({ showUserDetailModal: false })}
                        handleSelect={(selectedOption) => {
                            const selectedCustomers = this.state.userOptions.filter(opt =>
                                selectedOption.includes(opt.value)
                            );
                            this.setState({
                                newRoleOwners: selectedCustomers,
                                showUserDetailModal: false
                            });
                        }}
                        userids={this.state.userOptions.filter(option => option.value !== "*").map(cust => cust.value)}
                        selectedIds={this.state.newRoleOwners !== "" ? this.state.newRoleOwners.map(iCustomer => iCustomer.value) : []}
                        usertype={"U"}
                        loading={this.state.showUserDetailModal}
                        isMulti={true}
                    />
                ) : null}
                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} size="lg" enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Column Role" : "Add New Column Role"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box
                            sx={{
                                width: "100%",
                                "& .css-2vawn2-MuiTypography-root": {
                                    alignSelf: "center",
                                },
                            }}
                        >
                            {this.props.editOperation ? (
                                <Box sx={{ display: "flex", width: "100%", mb: 2 }}>
                                    <Typography sx={{ width: "30%" }}>Id</Typography>
                                    <Typography sx={{ fontWeight: "bold", width: "100%" }}>
                                        {this.props.sourceData.id}
                                    </Typography>
                                </Box>
                            ) : null}
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography sx={{ width: "30%" }}>
                                    Column Role <sup style={{ color: "red" }}>*</sup>
                                </Typography>
                                {this.props.editOperation ? (
                                    <Typography sx={{ width: "100%" }}>
                                        {this.state.newRole}
                                    </Typography>
                                ) : (
                                    <TextField
                                        margin="normal"
                                        sx={{ mb: 1 }}
                                        fullWidth
                                        size="small"
                                        label="Role (required)"
                                        placeholder="Enter Role"
                                        value={this.state.newRole}
                                        autoFocus
                                        onBlur={(e) => this.validateRolePresent(this.state.newRole)}
                                        onChange={(e) =>
                                            this.setState({
                                                newRole: e.target.value,
                                                showValidationMessage: false,
                                                roleValidationError: Utility.CheckIsPresent(
                                                    e.target.value
                                                )
                                                    ? ""
                                                    : "Role Cannot be Empty",
                                            })
                                        }
                                        helperText={this.state.roleValidationError}
                                        error={this.state.roleValidationError.length > 0}
                                    />
                                )}
                            </Box>
                            <Box display={"flex"} alignItems="center">
                                <Box minWidth={"25%"}></Box>
                                <Box>
                                    {this.state.validateRolePresentSpinner ? (
                                        <CircularProgress size="1rem" />
                                    ) : !this.state.showValidationMessage ? (
                                        <Box>&nbsp;</Box>
                                    ) : this.state.roleAvailable ? (
                                        <font color="green">Role available</font>
                                    ) : (
                                        <font color="red">Role not available</font>
                                    )}
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography sx={{ width: "30%" }}>Description</Typography>
                                <TextField
                                    sx={{ mt: 1 }}
                                    margin="normal"
                                    fullWidth
                                    size="small"
                                    label="Description"
                                    placeholder="Description"
                                    value={this.state.newdescription}
                                    onChange={(e) =>
                                        this.setState({
                                            newdescription: e.target.value,
                                        })
                                    }
                                />
                            </Box>
                            <Box sx={{ display: "flex", mt: 2 }}>
                                <Typography sx={{ width: "25%", alignSelf: "center" }}>
                                    Column Permission
                                </Typography>
                                <Box sx={{ width: "80%", m: 0 }}>
                                    <MultiSelect
                                        options={this.state.permissionOptions}
                                        value={this.state.newPermission}
                                        onChange={(e) => this.setState({ newPermission: e })}
                                        label={"All Permissions"}
                                    />
                                </Box>
                                {this.state.showPermissionLoadSpinner ? (
                                    <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                                ) : (
                                    <Tooltip title="Reload">
                                        <RefreshOutlinedIcon
                                            color="primary"
                                            fontSize="medium"
                                            onClick={() => this.getAllPermission(true)}
                                            sx={{ cursor: "pointer", mt: 1 }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                            <Box sx={{ display: "flex", mt: 2 }}>
                                <Typography sx={{ width: "25%", alignSelf: "center" }}>
                                    Owners
                                </Typography>
                                <Box sx={{ width: "80%", m: 0 }}>
                                    <Select menuPlacement="auto"
                                        blurInputOnSelect={false}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        value={this.state.newRoleOwners}
                                        isSearchable={true}
                                        isMulti
                                        closeMenuOnSelect={true}
                                        name="All Users"
                                        options={this.getFilteredUserOptions()}
                                        onChange={(e) => this.setState({ newRoleOwners: e })}
                                        inputValue={this.state.userInputValue}
                                        onInputChange={(inputValue) => this.setState({ userInputValue: inputValue })}
                                    />
                                </Box>
                                <Tooltip title="View More Data">
                                    <span style={{ cursor: "pointer", marginLeft: "6px", marginTop: "5px" }}>
                                        <OpenInNewIcon
                                            fontSize="medium"
                                            color="action"
                                            onClick={() => this.setState({ showUserDetailModal: true })}
                                        />
                                    </span>
                                </Tooltip>
                                {this.state.showUserLoadSpinner ? (
                                    <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                                ) : (
                                    <Tooltip title="Reload">
                                        <RefreshOutlinedIcon
                                            color="primary"
                                            fontSize="medium"
                                            onClick={() => this.getAllUser(true)}
                                            sx={{ cursor: "pointer", mt: 1 }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
